module.exports = __webpack_public_path__ + "static/img/xuanzhongyouxi.png@2x.084ed3b8.png";